"use client";

import React, { memo } from "react";
import { Container } from "react-bootstrap";
import "./index.css";
import { AeroRight, HomeIcon } from "@/utlility/icons";
import { colors } from "@/app/Colors";
import Link from "next/link";
import Image from "next/image";

const PageTitle = ({
  image,
  name,
  type = "",
  subTitle,
  subHref,
  petaTitle,
  petaHref,
  marketAreaName = null,
  marketAreaSlug = null,
  isCategory = false
}) => {

  return (
    <section className="position-relative comman-page mt-0">
      <div className="position-relative comman-page-title">
        <div className="image">
          <Image
            src={image}
            width={1920}
            height={350}
            className="img-fluid w-100 object-fit-cover"
            priority
            fetchPriority="high"
            alt={name}
            title={name}
            sizes="(max-width: 768px) 70vw, 100vw"
          />
        </div>

        <div className="background h-100 w-100 top-0 start-0 position-absolute">
          <Container className="h-100 d-flex align-items-center position-relative justify-content-center justify-content-sm-start">
            <h1 className="page-title fw-bold text-capitalize">
              {marketAreaName ? `${name} in ${marketAreaName}` : name}
            </h1>
          </Container>
        </div>
      </div>

      <Container className="position-relative">
        <div className="path-section position-absolute z-3">
          <div className="position-relative path-section-cover">
            <div className="page-text d-flex flex-wrap align-items-center">

              {/* Home */}
              <Link href="/" className="text-capitalize">Home</Link>
              {/* <span className="next-icon">
                <AeroRight color={colors["--text-primary"]} />
              </span> */}

              {/* Blog breadcrumb */}
              {type === "blog" && (
                <>
                  <span className="next-icon">
                    <AeroRight color={colors["--text-primary"]} />
                  </span>
                  <Link href="/blog" className="text-capitalize text-truncate">blog</Link>
                </>
              )}

              {/* Sub Title breadcrumb */}
              {subTitle && (
                <>
                  <span className="next-icon">
                    <AeroRight color={colors["--text-primary"]} />
                  </span>
                  <Link
                    href={marketAreaSlug ? `${subHref}-in-${marketAreaSlug}` : subHref}
                    className="text-capitalize"
                  >
                    {subTitle}
                  </Link>
                </>
              )}

              {/* Peta Title breadcrumb */}
              {petaTitle && (
                <>
                  <span className="next-icon">
                    <AeroRight color={colors["--text-primary"]} />
                  </span>
                  <Link
                    href={marketAreaSlug ? `${petaHref}-in-${marketAreaSlug}` : petaHref}
                    className="text-capitalize"
                  >
                    {petaTitle}
                  </Link>

                </>
              )}

              {/* Current page name */}
              {name && !isCategory && (<>
                <span className="next-icon">
                  <AeroRight color={colors["--text-primary"]} />
                </span>
                <span className="text-capitalize">{name}</span></>)}

            </div>
            <div className="position-absolute top-50 start-0 translate-middle home-icon-cover text-center">
              <i>
                <HomeIcon color={colors["--text-primary"]} />
              </i>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default memo(PageTitle);